import lrCodeEditor2 from './_src/lrCodeEditor2.vue'

lrCodeEditor2.install = function(Vue) {
  Vue.component(lrCodeEditor2.name, lrCodeEditor2)
}

export default lrCodeEditor2